import { ButtonGreen } from 'components/buttons/default-green';
import Image from 'next/image';
import { useState } from 'react';

interface PlansTableProps {
  plans: {
    id: string;
    name: string;
    price: string;
    url: string;
    featured: boolean;
    usePhoneNumber: boolean;
  }[];
  children: React.ReactNode[];
}

export function PlansTable(props: PlansTableProps) {
  const { plans, children } = props;
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null);

  const clones = children.map((child: any, index: number) => {
    return {
      ...child,
      props: {
        ...child.props,
        block: {
          ...child.props.block,
          component: {
            ...child.props.block.component,
            options: {
              ...child.props.block.component.options,
              index: index,
              availablePlans: plans,
              selectedPlan: selectedPlan
            }
          }
        }
      }
    };
  });

  return (
    <div>
      <div className="mb-[16px] hidden flex-col justify-between gap-[16px] lg:flex lg:flex-row lg:items-end">
        <h3 className="text-[32px] font-medium">Features</h3>
        <div className="flex-grow"></div>
        {plans.map((plan, index) => (
          <div
            key={index}
            className={`flex w-full cursor-default flex-col items-center justify-center gap-[10px] rounded-lg px-6 py-8 lg:w-[270px]`}
            style={{
              background: plan.featured
                ? 'radial-gradient(151.08% 82.12% at 104.65% 0%, #43BC4C 0%, #28712D 100%)'
                : 'white',
              color: plan.featured ? 'white' : '#4A4F4A'
            }}
          >
            <h4 className="text-[20px] font-medium">{plan.name}</h4>
            <p>
              <span className="text-[32px] font-bold">${plan.price}</span> / day
            </p>
            {plan.url && !plan.usePhoneNumber && (
              <a
                href={plan.url}
                className="flex w-full flex-row items-center justify-center gap-[10px] rounded-lg border border-fp-green bg-white px-4 py-2 text-sm text-fp-green"
              >
                <Image src="/icons/shopping-cart.svg" alt="arrow-right" width={12} height={12} />
                Shop Systems
              </a>
            )}
            {plan.usePhoneNumber && (
              <ButtonGreen
                href={`tel:833-606-4477`}
                className="flex w-full flex-row items-center justify-center gap-[10px] rounded-lg border-2 border-fp-green bg-white px-4 py-2 text-sm text-fp-green"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="size-4"
                >
                  <path
                    fillRule="evenodd"
                    d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>Call 833-606-4477</span>
              </ButtonGreen>
            )}
          </div>
        ))}
      </div>

      <div className="mb-[16px] flex flex-col justify-between gap-[16px] lg:hidden">
        <h3 className="text-[32px] font-medium">Plans</h3>
        {plans.map((plan, index) => (
          <div
            key={index}
            className={`flex w-full cursor-pointer flex-col items-center justify-center gap-[10px] rounded-lg px-6 py-8`}
            style={{
              background: plan.featured
                ? 'radial-gradient(151.08% 82.12% at 104.65% 0%, #43BC4C 0%, #28712D 100%)'
                : 'white',
              color: plan.featured ? 'white' : '#4A4F4A',
              border:
                selectedPlan === plan.id
                  ? plan.featured
                    ? '4px solid black'
                    : '4px solid #35823c'
                  : 'none'
            }}
            onClick={() => {
              setSelectedPlan(plan.id);
            }}
          >
            <h4 className="text-[20px] font-medium">{plan.name}</h4>
            <p className="hidden lg:flex">
              <span className="text-[32px] font-bold">${plan.price}</span> / day
            </p>
            <a
              href={plan.url}
              className="hidden w-full flex-row items-center justify-center gap-[10px] rounded-lg border border-fp-green bg-white px-4 py-2 text-sm text-fp-green lg:flex"
            >
              <Image src="/icons/shopping-cart.svg" alt="arrow-right" width={12} height={12} />
              Choose this plan
            </a>
            {selectedPlan === plan.id && (
              <>
                <p>
                  <span className="text-[32px] font-bold">${plan.price}</span> / day
                </p>
                <a
                  href={plan.url}
                  className="flex w-full flex-row items-center justify-center gap-[10px] rounded-lg border border-fp-green bg-white px-4 py-2 text-sm text-fp-green"
                >
                  <Image src="/icons/shopping-cart.svg" alt="arrow-right" width={12} height={12} />
                  Choose this plan
                </a>
              </>
            )}
          </div>
        ))}
      </div>

      <div className="hidden lg:block">{clones}</div>

      <div className="lg:hidden">
        {!!selectedPlan && (
          <>
            <h3 className="mb-4 mt-6 text-[32px] font-medium">Features</h3>
            {clones}
          </>
        )}
      </div>
    </div>
  );
}
